// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__2kRxy","buttons":"RemoveExpirationActionButtons_buttons__1ksTO"};